import React, { useEffect, useRef, useState } from "react";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { FormikHandlers } from "formik";
import { uploadContentImageApi } from "../../../features/exhibits/exhibits.api";
import { apiUrl } from "../../constants/apiUrl";

interface IProps {
  content: any;
  onChange: (value: any) => void;
  onBlur?: FormikHandlers["handleBlur"];
}

const Wysiwyg: React.FC<IProps> = ({ content, onChange, onBlur }) => {
  const editor = useRef<Editor>(null);

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [newContent, setNewContent] = useState([]);

  useEffect(() => {
    const contentBlock = htmlToDraft(content.content);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);

      setEditorState(editorState);
    }
  }, [content.content]);

  const handleChange = (editorState: EditorState) => {
    var copy = { ...content };
    if (editorState.getCurrentContent().hasText()) {
      copy.content = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    } else {
      copy.content = "";
    }

    setEditorState(editorState);
    setNewContent(copy);
  };

  const _uploadImageCallBack = async (file: any) => {
    const fileName = await uploadContentImageApi(file);
    return new Promise((resolve, reject) => {
      resolve({ data: { link: `${apiUrl}/exhibits/content/${fileName}` } });
    });
  };

  const _handleLinkCallback = (link: any) => {
    if (link.title.trim() != "" && link.target.trim() != "")
      editor.current!.focusEditor();

    var regex = /^(http|https)/;
    var target = link.target;
    if (!regex.test(String(target).toLowerCase())) {
      target = `https://${link.target}`;
    }

    return {
      title: link.title,
      target: target,
      targetOption: link.targetOption,
    };
  };

  return (
    <Editor
      ref={editor}
      editorState={editorState}
      wrapperClassName="editorWrapper"
      editorClassName="editor"
      toolbarClassName="editorToolbar"
      onEditorStateChange={handleChange}
      onBlur={() => {
        onChange(newContent);
      }}
      stripPastedStyles={true}
      toolbar={{
        options: [
          "inline",
          "blockType",
          "fontSize",
          "fontFamily",
          "list",
          "textAlign",
          "link",
          "embedded",
          "emoji",
          "image",
          "remove",
          "history",
        ],
        link: {
          linkCallback: _handleLinkCallback,
        },
        image: {
          className: undefined,
          component: undefined,
          popupClassName: undefined,
          urlEnabled: true,
          uploadEnabled: true,
          alignmentEnabled: false,
          uploadCallback: _uploadImageCallBack,
          previewImage: true,
          inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
          alt: { present: true, mandatory: false },
        },
      }}
    />
  );
};

export default Wysiwyg;
